import { render, staticRenderFns } from "./ImportarInformacion.vue?vue&type=template&id=42f70736&scoped=true&"
import script from "./ImportarInformacion.vue?vue&type=script&lang=js&"
export * from "./ImportarInformacion.vue?vue&type=script&lang=js&"
import style0 from "./ImportarInformacion.vue?vue&type=style&index=0&id=42f70736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f70736",
  null
  
)

export default component.exports